import React from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../hooks/auth";

interface Params {
    token: string;
}

function Token() {

    const auth = useAuth();
    const params = useParams<Params>();

    React.useEffect(() => {
        handleLogin();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function handleLogin() {
        try {
            await auth.login(params.token);
        } catch (error) {
            alert("O token é inválido ou expirou!");
            window.close();
        }
    }

    return null;
}

export default Token;